import React from 'react';
import './Avatar.css';

interface AvatarProps {
  user_name: string; // required
  image?: string;    // optional image URL
  size?: number;     // optional size in pixels, default 56
  className?: string; // optional extra classes
}

const getInitials = (name: string) => {
  if (!name) return '';
  // Split by whitespace, filter empty parts, take first char of up to first two parts
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const initials = parts.slice(0, 2).map(p => p[0] || '').join('');
  return initials.toUpperCase();
};

const Avatar: React.FC<AvatarProps> = ({ user_name, image, size = 56, className = '' }) => {
  const initials = getInitials(user_name);

  const fontSize = Math.max(10, Math.round(size * 0.42));

  return (
    <div
      className={`avatar ${className}`}
      style={{ width: size, height: size, fontSize }}
      aria-label={user_name}
      title={user_name}
    >
      {image ? (
        <img
          src={image}
          alt={user_name}
          className="avatar-image"
          width={size}
          height={size}
          loading="lazy"
          referrerPolicy="no-referrer"
        />
      ) : (
        <span className="avatar-initials" aria-hidden>
          {initials}
        </span>
      )}
    </div>
  );
};

export default Avatar;
